export default "__VITE_ASSET__KTIHzVD0__"